import { ReactNode } from 'react';

import { Box } from 'components/Box';

import { List } from './BulletList.styled';

type Props = {
  items: Array<{
    key: string | number;
    value: ReactNode;
  }>;
  columns?: 1 | 2;
  itemMargin?: number;
  mt?: number;
  'data-qa-id'?: string;
};

export function BulletList({
  items,
  columns = 1,
  itemMargin = 0,
  mt,
  'data-qa-id': qaId,
}: Props) {
  return (
    <Box
      component={List}
      classes={['flex']}
      mb={`-${itemMargin}px`}
      mt={mt}
      data-qa-id={qaId}
    >
      {items.map(
        ({ key, value }) =>
          value && (
            <Box
              component="li"
              key={key}
              width={[1, 1, 1, 1 / columns]}
              mb={`${itemMargin}px`}
            >
              {value}
            </Box>
          ),
      )}
    </Box>
  );
}
